import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

import SpecialText from '../fragments/SpecialText';

export default function Quote({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const textRevealRef = useReveal({ once: true });
    const text_maximum_width = block.text_maximum_width ? block.text_maximum_width + 'em' : '30em';

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--quote`}>
            <div className={`l-grid`}>
                <div className={`l-grid__col`}>
                    <div className="c-quote c-transition-in--top-border c-transition-in c-transition-in--bottom-border" ref={textRevealRef}>
                        <div className="l-small-top-padding l-small-bottom-padding">
                            {block.quote &&
                                <h3 className="c-quote__text c-heading c-heading--accent" style={{ maxWidth: text_maximum_width }}>
                                    <SpecialText text={block.quote} />
                                </h3>
                            }
                            {block.source &&
                                <p className="c-quote__cite c-paragraph" dangerouslySetInnerHTML={{__html:block.source}} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}